export default "__VITE_ASSET__kO8boTvu__"